var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHair4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 753 762.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-hair-1 {\n        fill: var(--custom-color, #fbb03b) !important;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-hair-1",
    d: "M718.63,691.9c-7.22,0-14.25-.84-20.99-2.43-17.69,28.37-40.69,53.08-67.61,72.75h76.5c25.66,0,46.47-20.81,46.47-46.47v-30.55c-10.61,4.31-22.21,6.69-34.37,6.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-hair-1",
    d: "M15.09,511v-38.38c0-21.09,1.82-41.76,5.29-61.86,71.44-7.56,181.99-28.51,301.93-91.25,101-52.84,173.36-116.85,220.79-166.86,115.2,60.28,193.81,180.94,193.81,319.97v38.38c5.57,1.13,10.94,2.78,16.09,4.87v-248.68h0v-5.56c0-2.31-.12-4.58-.3-6.84C746.22,112.98,629.22,0,485.81,0h-218.62C123.78,0,6.78,112.98.3,254.79c-.18,2.26-.3,4.54-.3,6.84v5.56h0v248.26c4.84-1.9,9.89-3.4,15.09-4.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-hair-1",
    d: "M54.35,689.48c-6.74,1.58-13.76,2.43-20.99,2.43-11.78,0-23.03-2.23-33.37-6.29v30.14c0,25.66,22.34,46.8,48,46.8h.21l72.66-.33h1.1c-26.92-19.67-49.92-44.38-67.61-72.75Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHair4);
export default __webpack_public_path__ + "static/media/hair4.70763fb6790d57f104a3de9a2d159c14.svg";
export { ForwardRef as ReactComponent };